module.exports = __webpack_public_path__ + "static/media/img-masterplan.d39e1f1e.png";